export const VIEW_DISTANCE_FROM = "View distance of this hotel from...";
